import { cva, VariantProps } from 'class-variance-authority';
import { HTMLAttributes } from 'react';

const progressBarClassNames = cva('tw-absolute tw-left-0 tw-z-10 tw-h-full tw-transition-all', {
    variants: {
        color: {
            success: 'tw-bg-success',
            error: 'tw-bg-error',
            light: 'tw-bg-accents-5'
        }
    },
    defaultVariants: {
        color: 'light'
    }
});

const progressClassNames = cva('tw-relative tw-overflow-hidden tw-rounded-md tw-bg-accents-1', {
    variants: {
        size: {
            xs: 'tw-h-1',
            sm: 'tw-h-1.5',
            md: 'tw-h-2',
            lg: 'tw-h-3',
            xl: 'tw-h-4'
        }
    },
    defaultVariants: {
        size: 'md'
    }
});

type ProgressBarVariants = VariantProps<typeof progressBarClassNames>;
type ProgressVariants = VariantProps<typeof progressClassNames>;

interface Props
    extends Omit<HTMLAttributes<HTMLDivElement>, keyof ProgressBarVariants>,
        ProgressBarVariants,
        ProgressVariants {
    progress: number;
}

const Progress = ({ className, progress, size, color, ...props }: Props) => {
    return (
        <div className={progressClassNames({ size, className })} {...props}>
            <div
                className={progressBarClassNames({ color })}
                style={{ width: `${progress * 100}%`, transitionDuration: '1000ms' }}
            />
        </div>
    );
};

export default Progress;
